/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import Header from "containers/common/Header";
import router from "config/router";
import { Route } from "react-router-dom";
import HomeContainer from "containers/common/HomeContainer";
import { getWholesalerList } from "reducers/wholesalers";
import { categoryMenuRequest } from "reducers/categoryMenu";
import PrivateRoutesAuthWrapper from "app/authWrapper/PrivateRoutesAuthWrapper";
import { getCartDetails } from "reducers/cart";
import { loadAppSettingConfig } from "reducers/common/appSettings";
import { getOrderHistory } from "reducers/orderHistory";
import { getStaticContentList } from "reducers/common/staticContent"
import { getSalesReturnSummary } from "reducers/salesReturn/salesReturnSummary";
import { getSalesReturnReasons } from "reducers/common";
import DocumentPageTitle from "components/reusable/DocumentPageTitle";

/* TODO: Need to complete the push notification then enable for commit */
/* import { updateFcmToken } from "reducers/localStore"; */
/* import { messaging, requestForFcmToken } from "config/firebaseInit"; */

/* Project Import will be here */

class IvyRouterContainer extends React.Component {
  async componentDidMount() {
    /* Get the system configuration related information */
    await this.props.actions.loadAppSettingConfig();

    /* Get the Wholesaler list when the application is loaded */
    await this.props.actions.getWholesalerList(false);

    /* Get the menu list when the application is loaded */
    this.props.actions.categoryMenuRequest();

    /* Get the order history details */
    await this.props.actions.getOrderHistory();

    await this.props.actions.getCartDetails();

    await this.props.actions.getSalesReturnSummary();

    await this.props.actions.getSalesReturnReasons();

    /* Get static contents */
    this.props.actions.getStaticContentList();

    /* TODO: Need to complete the push notification then enable for commit */
    /* Request for firebase push notification config */
    /*  if (messaging !== null) {
       requestForFcmToken(this.onFcmTokenCallback);
     } */
  }

  /* TODO: Need to complete the push notification then enable for commit */
  /* Update FCM token during the application loading */
  /* onFcmTokenCallback = (token) => {
    this.props.actions.updateFcmToken(token);
  } */

  render() {
    return (
      <React.Fragment>
        {/* Set page title */}
        <DocumentPageTitle {...this.props} />

        {/* Header section */}
        <Header />

        {/* Main component section */}
        <HomeContainer>
          <Route path="/ivy" component={PrivateRoutesAuthWrapper(router)} />
        </HomeContainer>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        getCartDetails,
        getWholesalerList,
        loadAppSettingConfig,
        categoryMenuRequest,
        getOrderHistory,
        getStaticContentList,
        getSalesReturnSummary,
        getSalesReturnReasons,

        /* TODO: Need to complete the push notification then enable for commit */
        /* updateFcmToken */
      },
      dispatch
    )
  };
};

export default connect(null, mapDispatchToProps)(IvyRouterContainer);